export const limitString = (str?: string, limit?: number, replaceCar?: string) => {
  if (!str) return '';
  const replaceCarFound = replaceCar || '...';
  if (!limit) return str;
  return str.length > limit ? `${str.substring(0, limit)}${replaceCarFound}` : str;
}